import { InBoundConstants,InBoundGetIpDataConstants } from '../Constants';
import { adminUsersServices } from '../Services';

export const inboundActions = {
    searchInBound,
    searchInBoundGetip
};

function searchInBound(data: any) {
    return (dispatch:any) => {
        dispatch(dispatchFunction({
            type: InBoundConstants.SEARCH_INBOUND_REQUEST,
            data: null
        }));
        adminUsersServices.searchInBound(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: InBoundConstants.SEARCH_INBOUND_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: InBoundConstants.SEARCH_INBOUND_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: InBoundConstants.SEARCH_INBOUND_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}

function searchInBoundGetip(data: any) {
    return (dispatch:any) => {
        dispatch(dispatchFunction({
            type: InBoundGetIpDataConstants.SEARCH_INBOUNDGETIPDATA_REQUEST,
            data: null
        }));
        adminUsersServices.searchInBoundgetIP(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: InBoundGetIpDataConstants.SEARCH_INBOUNDGETIPDATA_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: InBoundGetIpDataConstants.SEARCH_INBOUNDGETIPDATA_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: InBoundGetIpDataConstants.SEARCH_INBOUNDGETIPDATA_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}

function dispatchFunction(data: any) {
    // To do: check for refresh / unauthorized error
    return {
        type: data.type,
        data: data.data
    };
}